import { baseApi } from '../../../core/baseApi';
import { createListQuery, createCreateMutation, createUpdateMutation, createDeleteMutation, unwrapApiResponse } from '../../../patterns/crud';
import { IntegrationsStatusResponse, Integration } from '../types';

export const integrationsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getIntegrations: createListQuery('/integrations', 'Integrations')(builder),
    // Custom query for /integrations/status - no ID parameter needed
    getIntegrationsStatus: builder.query<IntegrationsStatusResponse, void>({
      query: () => '/integrations/status',
      transformResponse: unwrapApiResponse,
      providesTags: ['IntegrationsStatus']
    }),
    configureIntegration: createCreateMutation('/integrations/configure', 'Integrations')(builder),
    updateIntegration: createUpdateMutation('/integrations', 'Integrations')(builder),
    deleteIntegration: createDeleteMutation('/integrations', 'Integrations')(builder),
    testIntegrationConnection: createCreateMutation('/integrations/test', 'IntegrationsStatus')(builder),
  })
});

export const {
  useGetIntegrationsQuery,
  useGetIntegrationsStatusQuery,
  useConfigureIntegrationMutation,
  useUpdateIntegrationMutation,
  useDeleteIntegrationMutation,
  useTestIntegrationConnectionMutation,
} = integrationsApi;

// Custom hook to check integration status
export const useIntegrationStatus = () => {
  const { data: integrationsData, isLoading, error } = useGetIntegrationsStatusQuery(undefined, {
    // Reduce timeout for this non-critical query
    // pollingInterval: 60000, // Poll every minute
    refetchOnMountOrArgChange: 300, // Only refetch after 5 minutes
  });

  // Safely get integrations array from properly typed response
  const integrationsArray: Integration[] = integrationsData?.integrations || [];

  // Check if Hawksoft is connected
  const isHawksoftConnected = integrationsArray.some(
    (integration) =>
      integration.integrationType === 'hawksoft' &&
      integration.isActive === true
  );

  return {
    isHawksoftConnected,
    isLoading,
    error,
    integrations: integrationsArray
  };
};